import Glide from '@glidejs/glide';
import { setRangeMax, handleCarouselButtons, handlePadding } from '../../../helpers/carouselRange';

const itemCardCarousels: NodeListOf<HTMLDivElement> = document.querySelectorAll('.item-carousel__inner');

if (itemCardCarousels.length > 0) {
    itemCardCarousels.forEach((item) => {
        var glide = new Glide(item, {
            type: 'slider',
            perView: 3,
            gap: 20,
            rewind: false,
            bound: true,
            breakpoints: {
                992: {
                    perView: 2.5,
                },
                800: {
                    perView: 1.7,
                },
                550: {
                    perView: 1.2,
                },
            },
        });

        glide.mount();

        const carouselContainer = item.parentElement as HTMLElement;
        const carouselRange = item.querySelector('.item-carousel__range') as HTMLInputElement;

        carouselRange.addEventListener('input', (e) => {
            setTimeout(() => {
                glide.go(`=${carouselRange.value}`);
            }, 500);
        });

        const slides: NodeListOf<HTMLDivElement> = item.querySelectorAll('.item-carousel__item');
        setRangeMax(slides, carouselRange, glide.settings.perView);
        handleCarouselButtons(slides, glide.settings.perView, item, glide)
        handlePadding(slides, glide.settings.perView, carouselContainer)

        glide.on('move.after', () => {
            const currentIndex = glide.index;
            carouselRange.value = currentIndex;
        });

        glide.on('resize', () => {
            setRangeMax(slides, carouselRange, glide.settings.perView);
            handleCarouselButtons(slides, glide.settings.perView, item, glide);
            handlePadding(slides, glide.settings.perView, carouselContainer)
            glide.go(`=0`);
        });

        if(slides.length < 3) {
            const carouselItems: NodeListOf<HTMLElement> = item.querySelectorAll('.item-carousel__item');

            carouselItems.forEach((item) => {
                item.style.flex = "1";
            })
        }
    });
}
